import { House, UsersThree, Buildings, WarningCircle } from "@phosphor-icons/react";
import type { Icon } from "@phosphor-icons/react";
import { FAQ_PLACEMENTS, type FaqPlacement } from "@/lib/faq-categories";

/** Ikona + prevodni ključ po stranici, dijele ih tabovi i dijalog kategorije. */
export const FAQ_PLACEMENT_META: Record<FaqPlacement, { icon: Icon; labelKey: string }> = {
  home: { icon: House, labelKey: "faqAdmin.placementHome" },
  therapists: { icon: UsersThree, labelKey: "faqAdmin.placementTherapists" },
  companies: { icon: Buildings, labelKey: "faqAdmin.placementCompanies" },
};

/**
 * Sitne oznake stranica na kojima kategorija izlazi. Prazan raspored dobija
 * eksplicitno upozorenje: kategorija koja nije nigdje dodijeljena se javno ne
 * vidi, a bez markera to izgleda isto kao i ispravno postavljena.
 */
export function FaqPlacementIcons({
  placements,
  title,
  className = "",
}: {
  placements: readonly FaqPlacement[];
  title: string;
  className?: string;
}) {
  if (placements.length === 0) {
    return <WarningCircle className={`size-3.5 shrink-0 text-amber-600 ${className}`} weight="fill" aria-label={title} />;
  }

  return (
    <span className={`inline-flex shrink-0 items-center gap-0.5 ${className}`} title={title}>
      {FAQ_PLACEMENTS.filter((p) => placements.includes(p)).map((p) => {
        const Icon = FAQ_PLACEMENT_META[p].icon;
        return <Icon key={p} className="size-3.5" weight="regular" />;
      })}
    </span>
  );
}
